import React, { useState } from "react";
import axios from "axios";
import "./App.css";

export default function Weather() {
  const [city, setCity] = useState("");
  const [find, setFind] = useState(false);
  const [temp, setTemp] = useState({});

  function displayCityForecast(response) {
    setFind(true);
    setTemp({
      temperature: response.data.main.temp,
      wind: response.data.wind.speed,
      humidity: response.data.main.humidity,
      icon: `http://openweathermap.org/img/wn/${response.data.weather[0].icon}@2x.png`,
      description: response.data.weather[0].description,
    });
  }

  function handelSubmit(event) {
    event.preventDefault();
    let apiKey = "6171d3dc3ef7fcb234a226d28af1fb1b";
    let apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`;
    axios.get(apiUrl).then(displayCityForecast);
  }

  function updateCity(event) {
    setCity(event.target.value);
  }

  let form = (
    <div>
      <form onSubmit={handelSubmit}>
        <input
          type="search"
          placeholder="Enter City.."
          autoFocus="on"
          onChange={updateCity}
        />{" "}
        <br />
        <br />
        <button type="submit"> Let's Search </button>
      </form>
      <footer>
        {" "}
        Coded by
        <a href="https://github.com/Tinymrsb"> Brittany</a> 2022
      </footer>
    </div>
  );

  if (find) {
    return (
      <div class="container-sm">
        {form}
        <ul class="col-sm pt-3 list-group">
          <li class="list-group-item"> {city} </li>
          <li class="list-group-item">
            Temperature: {Math.round(temp.temperature)}°C
          </li>
          <li class="list-group-item">Description: {temp.description}</li>
          <li class="list-group-item">Humidity: {temp.humidity}%</li>
          <li class="list-group-item">Wind: {temp.wind}km/h</li>
          <li class="list-group-item">
            <img src={temp.icon} alt={temp.description} />
          </li>
        </ul>

        <footer>
          {" "}
          Open-source code available on{" "}
          <a href="https://github.com/Tinymrsb">GitHub</a>
        </footer>
      </div>
    );
  } else {
    return form;
  }
}
